module.exports = __webpack_public_path__ + "img/logoEy.0294a79b.svg";